import { render, staticRenderFns } from "./XTableHead.vue?vue&type=template&id=3d7a9b71&"
import script from "./XTableHead.vue?vue&type=script&lang=js&"
export * from "./XTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports